<template>
    <div class="auth-methods">
	    <div class="btns">
		    <a @click="loginWithGoogle" class="google-auth">
			    <div class="icon"><inline-svg :src="require('@/assets/img/google-icon.svg')"/></div>
			    Continue with Google
		    </a>
		    <a @click="loginWithFacebook" class="fb-auth">
			    <div class="icon"><inline-svg :src="require('@/assets/img/fb-icon.svg')"/></div>
			    Continue with Facebook
		    </a>
	    </div>
	    <p class="or">Or</p>
    </div>
</template>
<script>
import API from "@/api"
const moment = require('moment-timezone');

export default {
	name: "AuthMethods",
	components: {},
	props: {
		login: {
			default: false,
			type: Boolean,
		}
	},
	mixins: [API],
	data: function () {
		return {
			userLogin: '',
			userPassword: '',
			error: false
		}
	},
	computed: {
		mtd() {
			return this.login ? "in" : "up";
		}
	},
	// mounted() {
	// 	let ref = this.$cookies.get("funnelish-ref")
	// 	console.log("ref", ref)
	// },
	methods:{
		loginWithGoogle () {
			let ref = this.$cookies.get("funnelish-ref")
			let tz = moment.tz.guess();

			let url = `api/v1/auth/google-login?login=${this.login}&ref=${ref}&tz=${tz}`;
			if (window.location.host.indexOf('localhost')>=0) {
				url = `https://beta.funnelish.com/api/v1/auth/google-login?login=${this.login}&ref=${ref}&tz=${tz}`;
			}
			window.open(url, '_self')
		},
		loginWithFacebook () {
			let ref = this.$cookies.get("funnelish-ref")
			let tz = moment.tz.guess();

			let url = `api/v1/auth/facebook-login?login=${this.login}&ref=${ref}&tz=${tz}`;
			if (window.location.host.indexOf('localhost')>=0) {
				url = `https://beta.funnelish.com/api/v1/auth/facebook-login?login=${this.login}&ref=${ref}&tz=${tz}`;
			}
			window.open(url, '_self')
		},
	}
}
</script>
<style lang="scss" scoped>

.auth-methods {
	margin-top: 5px;
	margin-bottom: 5px;
	text-align: center;
	.btns {
		display: flex;
		flex-direction: column;
		align-content: stretch;
		row-gap: 12px;
		justify-items: stretch;
		justify-content: space-evenly;
		margin-bottom: 10px;
	}
}

.auth-methods a {
	background-color: #fff;
	padding: 7px 15px;
	font-weight: 600;
	border-radius: 6px;
	letter-spacing: 0.02em;
	color: $darker-grey;
	display: flex;
	align-items: center;
	transition: 0.3s;
	justify-content: center;
	width: 100%;
	border: 1px solid $light-grey;
	box-shadow: rgba(15, 15, 15, 0.05) 0px 1px 2px;
	&:hover {
		background: $light-silver;
		border: 1px solid $grey;
	}
}

.auth-methods a .icon {
	display: flex;
	margin-right: 12px;
}

.auth-methods p {
	text-align: center;
	font-size: 16px;
	letter-spacing: 0.02em;
	color: #636A7B;
	margin-top: 5px;
	margin-bottom: 5px;
}

.auth-methods .or {
	position: relative;
	display: inline-block;
	font-size: 14px;
}

.auth-methods .or::before,
.auth-methods .or::after {
	content: "";
	width: 100px;
	height: 1px;
	background-color: #C5C7D2;
	position: absolute;
	top: 50%;
}

.auth-methods .or::before {
	left: 32px;
}

.auth-methods .or::after {
	right: 32px;
}

</style>
